import React from "react"
import { ReactComponent as Art } from "../images/icons/art.svg"
import { ReactComponent as Search } from "../images/icons/search.svg"
import { ReactComponent as Cross } from "../images/icons/cross.svg"
import { ReactComponent as IndustrialDesign } from "../images/icons/industrial_design.svg"
import { ReactComponent as Mail } from "images/icons/mail.svg"
import { ReactComponent as Message } from "images/icons/message.svg"
import { ReactComponent as Name } from "images/icons/name.svg"
import { ReactComponent as Title } from "images/icons/title.svg"
import { ReactComponent as Phone } from "images/icons/phone.svg"
import { ReactComponent as Latte } from "images/icons/latte.svg"

const iconMap = {
  art: { icon: Art },

  "industrial-design": { icon: IndustrialDesign },
  search: { icon: Search },
  cross: { icon: Cross },
  "mail" : {icon : Mail},
  "message" : {icon : Message},
  "name" : {icon : Name},
  "title" : {icon : Title},
  "phone" : {icon : Phone},
  "latte" : {icon : Latte}
}

export const hasIcon = name => {
  return !!iconMap[name]
}

export const Icon = ({ name }) => {
  return iconMap[name] ? React.createElement(iconMap[name].icon) : false
}
